import React from "react";
import { PermisionDenied } from "../../common/commonComponents";
import { isRestrictedBu } from "./utils";
import { useGetCollectPaymentContext } from "./context";

const PermissionWrapper = ({ children }) => {
  const { studentBasicDetails } = useGetCollectPaymentContext();

   const isCollectionModuleAllowed = isRestrictedBu(studentBasicDetails?.bu);
  if (isCollectionModuleAllowed) return <PermisionDenied />;
  return <div>{children}</div>;
};

export default PermissionWrapper;
